import { HttpService } from 'shared-utils';

const httpService = new HttpService();

export default httpService;